module.exports = __webpack_public_path__ + "img/food.5f2b2d36.jpg";